import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

class FeaturedTestimonials extends HTMLElement {
  constructor() {
    super();
    this.mobileBreakpoint = 800; // Define mobile breakpoint
    this.swiper = null;
  }

  connectedCallback() {
    const sliderContainer = this.querySelector('.swiper');

    // Initial check
    this.initOrDestroySlider(window.innerWidth);

    this.resizeObserver = new ResizeObserver((entries) => {
      const width = entries[0].contentRect.width;
      this.initOrDestroySlider(width);
    });

    if (sliderContainer) {
      this.resizeObserver.observe(sliderContainer);
    }
  }

  initOrDestroySlider(width) {
    const sliderContainer = this.querySelector('.swiper');

    if (width <= this.mobileBreakpoint) {
      // Initialize only if not already initialized
      if (!this.swiper) {
        this.swiper = new Swiper(sliderContainer, {
          slidesPerView: 1,
          resizeObserver: true,
          modules: [Pagination],
          autoHeight: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
          },
        });
      }
    } else {
      // Destroy if exists
      if (this.swiper) {
        this.swiper.destroy(true, true); // true, true means to destroy instance and DOM changes
        this.swiper = null;
      }
    }
  }

  disconnectedCallback() {
    // Clean up
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

customElements.define('featured-testimonials', FeaturedTestimonials);
